import React from "react";
import "./landing.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination"; 

import Image1 from "../../../assets/images/landingGroup1.svg";
import Image2 from "../../../assets/images/landingGroup2.svg";
import Image3 from "../../../assets/images/landingGroup3.svg";

function Landing() {
  return (
    <section id="landing-carousel" className="landing-carousel">
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        loop={true}
        pagination={{ clickable: true }}
        className="swiper-container"
      >
        <SwiperSlide>
          <img src={Image1} alt="Slide 1" className="landing-carousel-image" />
        </SwiperSlide>
        <SwiperSlide>
          <div className="carousel-slide-with-button">
            <img src={Image2} alt="Slide 2" className="landing-carousel-image" />
            <a
              href="/services#hep"
              className="carousel-img2-button"
            >
              Find your HEP
            </a>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img src={Image3} alt="Slide 3" className="landing-carousel-image" />
        </SwiperSlide>
      </Swiper>
    </section>
  );
}

export default Landing;